"use client";

import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

interface StarRatingProps {
  rating: number;
  max?: number;
  size?: number;
  interactive?: boolean;
  onChange?: (rating: number) => void;
  className?: string;
}

export function StarRating({
  rating, max = 5, size = 16, interactive = false, onChange, className,
}: StarRatingProps) {
  return (
    <div className={cn("flex items-center gap-0.5", className)}>
      {Array.from({ length: max }).map((_, i) => {
        const filled = i < Math.floor(rating);
        return (
          <button
            key={i}
            type="button"
            disabled={!interactive}
            onClick={() => interactive && onChange?.(i + 1)}
            className={cn(
              "relative",
              interactive && "hover:scale-110 transition-transform cursor-pointer",
              !interactive && "cursor-default"
            )}
            style={{ width: size, height: size }}
            aria-label={`${i + 1} yıldız`}
          >
            <Star
              style={{ width: size, height: size }}
              className={cn(
                "absolute inset-0 transition-colors",
                filled ? "fill-amber-400 text-amber-400" : "fill-gray-100 text-gray-200",
                interactive && !filled && "group-hover:fill-amber-200"
              )}
            />
          </button>
        );
      })}
    </div>
  );
}
